import React, { Component, Children } from 'react';
import PropTypes from 'prop-types';
import { replace } from 'react-router-redux';
import qs from 'qs';
import { flashErrorMessage } from '../../../actions/flash';
import { fetchM } from '../../../actions/fetchM';
import isNumber from '../../../utils/numbers/isNumber';
import { checkChanges } from '../../../utils/checkChanges';
import {
  NEW_PROJECT_UNIT_LAYOUT_PROMPT,
} from '../../../constants/promptMessages';

import List from './List';
import New from './New';
import Compare from './Compare';

import '../../../styles/containers/project/unitLayouts/compare.less';

export default class UnitLayouts extends Component {
  static propTypes = {
    params: PropTypes.shape({
      id: PropTypes.string,
    }),
    children: PropTypes.node,
    location: PropTypes.shape({
      pathname: PropTypes.string,
      query: PropTypes.object,
    }),
    data: PropTypes.shape({
      maOwnerCompanyBranchID: PropTypes.number,
    }),
  }
  static contextTypes = {
    store: PropTypes.object,
  }

  static List = List
  static New = checkChanges(New, { message: NEW_PROJECT_UNIT_LAYOUT_PROMPT })
  static Compare = Compare

  constructor(props) {
    super(props);
    this.state = {
      token: null,
      count: 0,
      limit: 0,
      offset: 0,
      loading: true,
      datas: [],
    };
  }
  componentDidMount() {
    const { query } = this.props.location;
    this.fetchProjectUnitLayouts(query);
  }
  componentWillReceiveProps(nextProps) {
    const { pathname, query } = nextProps.location;
    if (!pathname.includes('/new/')) {
      if (!this.state.loading) {
        this.fetchProjectUnitLayouts(query);
      }
    }
  }
  setUnitLayouts(datas = []) {
    return new Promise((res) => {
      this.setState({
        datas: datas || [],
      }, () => {
        res(datas);
      });
    });
  }
  setComponentState(state = {}) {
    return new Promise((res) => {
      this.setState(state, () => {
        res(state);
      });
    });
  }
  setLoading(loading = false) {
    return new Promise((res) => {
      this.setState({ loading }, () => {
        res(loading);
      });
    });
  }
  async fetchProjectUnitLayouts(q) {
    await this.setLoading(true);
    const { store } = this.context;
    const query = Object.assign({}, q);
    if (!query.page || !isNumber(query.page) || query.page <= 0) {
      query.page = 1;
    }
    if (query.tab) {
      delete query.tab;
    }
    let res;
    try {
      res = await store.dispatch(fetchM(`/projects/${this.props.params.id}/unit_layouts/?${qs.stringify(query)}`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: 'An error occurred, please refresh page' }));
      await this.setLoading(false);
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const token = res.headers.get('X-Csrf-Token');
      const count = parseInt(res.headers.get('M-Data-count'), 10);
      const limit = parseInt(res.headers.get('M-Data-limit'), 10);
      const offset = parseInt(res.headers.get('M-Data-offset'), 10) || 0;
      const datas = await res.json();
      if (!datas && query.page > 1) {
        query.page = 1;
        store.dispatch(replace(`/projects/${this.props.params.id}/layouts/?${qs.stringify(query)}`));
      }
      await this.setUnitLayouts(datas);
      // handle token.. etc
      await this.setComponentState({
        token,
        count,
        limit,
        offset,
      });
    }
    await this.setLoading(false);
  }
  renderChild() {
    return Children.map(this.props.children, child => (
      React.cloneElement(child, {
        token: this.state.token,
        count: this.state.count,
        limit: this.state.limit,
        offset: this.state.offset,
        loading: this.state.loading,
        datas: this.state.datas,
        id: this.props.params.id,
        data: this.props.data,
      })
    ));
  }
  render() {
    return (
      <div>
        {this.renderChild()}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Project/UnitLayouts/UnitLayouts.jsx